export const GET_TASK = 'GET_TASK';
export const GET_TASK_SUCCESS = 'GET_TASK_SUCCESS';
export const GET_TASK_ERROR = 'GET_TASK_ERROR';
